
export class PropertiesLocales {
    items_steps_pt = [
        {name: 'Cliente'}, // 0
        {name: 'Ativo'}, // 1
        {name: 'Endereço'}, // 2
        {name: 'Ambiente'}, // 3
        {name: 'Tipo de OS'}, // 4
        {name: 'Confirmação'}, // 5

        {label_cmp_ativo_nroserie      : 'Número de Série'}, // 5
        {label_cmp_ativo_nropatrimonio : 'Número de Patrimônio'}, // 6
        {label_cmp_ativo_equipamento   : 'Equipamento'}, // 7
        {label_cmp_ativo_ambientes     : 'Ambientes'}, // 8

        {msg_service_required : 'Obrigatório!'}, // 9
        {msg_service_select_address : 'Selecione um Endereço.'}, // 10
        {msg_service_select_servicetype : 'Selecione um Tipo de Serviço.'}, // 11

        {msg_service_error_empresaid : 'Empresa Inválida'}, // 12
        {msg_service_error_firstaccess_fields : 'Email e Documento são campos obrigatórios.'}, // 13
        {msg_service_success : 'Sucesso!'}, // 14
        {msg_service_success_firstaccess  : 'Você recebera um email com seu login e senha.'}, // 15

        {msg_service_failed : 'Falhou!'}, // 16
        {msg_service_failed_firstaccess  : 'Falha no cadastro/recuperar acesso.'}, // 17
        {msg_service_error_login_fields : 'Login e Senha são campos obrigatórios'}, // 18

        {msg_service_success_os_create : 'Ordem de Serviço criado com sucesso!'}, // 19

        {name: 'Anexos'}, // 21
        {label_cmp_anexo_nome      : 'Nome do Arquivo'}, // 22
        {label_cmp_anexo_descricao      : 'Descrição'}, // 23
        {label_cmp_anexo_visualizar      : 'Visualizar'} // 24
    ];

    items_steps_es = [
        {name: 'Cliente'},
        {name: 'Activo'},
        {name: 'Dirección'},
        {name: 'Ambiente'},
        {name: 'Tipo de servicios'},
        {name: 'Confirmación'},

        {label_cmp_ativo_nroserie      : 'Número de Serie'},
        {label_cmp_ativo_nropatrimonio : 'Número de Patrimonio'},
        {label_cmp_ativo_equipamento   : 'Equipo'},
        {label_cmp_ativo_ambientes     : 'Entornos'},

        {msg_service_required : 'Obligatorio'},
        {msg_service_select_address : 'Seleccione una dirección.'},
        {msg_service_select_servicetype : 'Seleccione un tipo de servicio.'},

        {msg_service_error_empresaid : 'Empresa Invalida'},
        {msg_service_error_firstaccess_fields : 'Correo electrónico y documento son campos obligatorios.'},
        {msg_service_success : 'Éxito'},
        {msg_service_success_firstaccess  : 'Usted recibirá un email con su nombre de usuario y contraseña.'},

        {msg_service_failed : 'Falló'},
        {msg_service_failed_firstaccess  : 'Falla en el registro / recuperar acceso.'},
        {msg_service_error_login_fields : 'Login y contraseña son campos requeridos.'},

        {msg_service_success_os_create : 'Orden de servicio creado con éxito'},

        {name: 'Anexos'}, // 20
        {label_cmp_anexo_nome      : 'Nome do Arquivo'}, // 21
        {label_cmp_anexo_descricao      : 'Descrição'}, // 22
        {label_cmp_anexo_visualizar      : 'Preview'} // 22
    ];

    items_steps_en = [
        {name: 'Client'},
        {name: 'Equipament'},
        {name: 'Address'},
        {name: 'Ambient'},
        {name: 'Type of Services'},
        {name: 'Confirmation'},

        {label_cmp_ativo_nroserie      : 'Serial number'},
        {label_cmp_ativo_nropatrimonio : 'Heritage number'},
        {label_cmp_ativo_equipamento   : 'Equipament'},
        {label_cmp_ativo_ambientes     : 'Ambience'},

        {msg_service_required : 'Required!'},
        {msg_service_select_address : 'Select an Address.'},
        {msg_service_select_servicetype : 'Select a Service Type.'},

        {msg_service_error_empresaid : 'Company Invalid'},
        {msg_service_error_firstaccess_fields : 'Email and Document are required fields.'},
        {msg_service_success : 'Success!'},
        {msg_service_success_firstaccess  : 'You will receive an email with your login and password.'},

        {msg_service_failed : 'Failed!'},
        {msg_service_failed_firstaccess  : 'Failed to register / retrieve access.'},
        {msg_service_error_login_fields : 'Login and Password are required fields.'},

        {msg_service_success_os_create : 'Successfully created service order!'},

        {name: 'Anexos'}, // 20
        {label_cmp_anexo_nome      : 'File Name'}, // 21
        {label_cmp_anexo_descricao      : 'Description'}, // 22
        {label_cmp_anexo_visualizar      : 'Preview'} // 22
    ];

    constructor() { }

}
